module.exports = __webpack_public_path__ + "img/D_Read_more_compare_female.21ff41c0.svg";